import postPhoneNumber, {
	ISavePhoneNumberRequest,
} from "../../api/post/postPhoneNumber";
import { ICookieConfig } from "./setCookie";

const postPhoneNumberHelper = async (
	phoneType: string,
	cookieConfig: ICookieConfig,
	data: ISavePhoneNumberRequest
) => {
	switch (phoneType) {
		case `Assistant's`:
			await postPhoneNumber(
				cookieConfig.token,
				cookieConfig.personId,
				"Assistants",
				data
			);
			break;

		case "Mobile":
			await postPhoneNumber(
				cookieConfig.token,
				cookieConfig.personId,
				"Cell",
				data
			);
			break;

		case "Business":
			await postPhoneNumber(
				cookieConfig.token,
				cookieConfig.personId,
				"Business",
				data
			);
			break;

		case "Home":
			await postPhoneNumber(
				cookieConfig.token,
				cookieConfig.personId,
				"Home",
				data
			);
			break;

		case "Pager":
			await postPhoneNumber(
				cookieConfig.token,
				cookieConfig.personId,
				"Pager",
				data
			);
			break;

		default:
			break;
	}
};

export default postPhoneNumberHelper;
